const skill = [
  {
    id: 1,
    number: 'i.',
    name: 'UI / UX Design',
    description:
      'I design intuitive and visually balanced interfaces with Figma and Adobe XD, focusing on usability, interaction, and clear visual hierarchy.'
  },
  {
    id: 2,
    number: 'ii.',
    name: 'Frontend Development',
    description:
      'I build responsive and interactive interfaces using HTML, CSS, JavaScript, React.js, and Vue.js, with a focus on clean structure and smooth user experiences.'
  },
  {
    id: 3,
    number: 'iii.',
    name: 'UX Writing',
    description:
      'I enjoy turning complex ideas into clear, concise, and user-friendly content, making interfaces easier to understand and navigate.'
  },
  {
    id: 4,
    number: 'iv.',
    name: 'Visual Exploration',
    description:
      'Beyond digital products, I experiment with illustration and visual storytelling, exploring different styles and ways to communicate ideas visually.'
  }
];

export default skill;